import React, { useState } from 'react';
import { useTeam } from './TeamContext';

const Episode0 = () => {
  const { team, saveTeamDetails } = useTeam();
  const [newNullplatformApplicationNRN, setNullplatformApplicationNRN] = useState(team.nullplatform_application_nrn || '');


  const handleSubmit = () => {
    //const episodes_unlocked = team.episodes_unlocked || []
    //const episode_id = 0
    //const updatedEpisodes = episodes_unlocked.includes(episode_id)
    //  ? episodes_unlocked
    //  : [...episodes_unlocked, episode_id].sort((a, b) => a - b);

    const updatedTeam = {
      ...team,
      //episodes_unlocked: updatedEpisodes.join(','),
      nullplatform_application_nrn: newNullplatformApplicationNRN
    };

    saveTeamDetails(updatedTeam);
  };

  return (
    <div>
      <div className="mt-4">
        <div>
          <h2 className="font-lustra text-3xl text-white text-center mt-12 mb-6">
            Episodio 0: El Génesis de los Pagos
          </h2>
          <div className="mt-2 mb-2 text-lg space-y-4 text-white">
            <p>
              ¡Bienvenidos al comienzo de esta épica aventura intergaláctica! Antes de
              lanzarnos de lleno al caos cósmico de los pagos sin control, tenemos una misión crítica:
              poner en marcha los motores de su nave o, en términos menos poéticos, realizar el setup
              de las APIs y los componentes necesarios para comenzar a jugar.
            </p>
            <p>
              Este episodio es crucial. Sin un setup exitoso, sus sistemas estarán más muertos
              que una estrella colapsada, y las transacciones jamás llegarán a destino. Aquí es donde
              entra en escena <b>null/platform</b>, la herramienta que será su guía en este proceso.
              Suena simple, ¿verdad? Bueno, no tan rápido...
            </p>
            <p>
              La paciencia será fundamental ya que posiblemente este sea un territorio desconocido para
              agunos de ustedes, y navegar por <span className="font-bold">null/platform</span> será un
              ejercicio de descubrimiento, intuición y, en algunos casos, nervios de acero. ¿Ágil y rápido?
              Sí. ¿Sin frustraciones? Eso está por verse... Pero confíen en nosotros, todo esfuerzo valdrá
              la pena cuando vean sus sistemas brillar como una supernova perfectamente configurada.
            </p>
            <p>
              Una advertencia: cualquier error aquí puede perseguirlos hasta el borde de la galaxia.
              Así que, revisen dos veces cada conexión, confirmen cada componente, y mantengan la calma.
              El futuro de su equipo depende de ello.
            </p>
            <p>
              Ahora que hemos establecido la importancia del setup inicial, es momento de detallar ciertos
              "pequeños" requisitos que no deben, bajo ninguna circunstancia, pasarse por alto. Como diría cualquier
              manual interestelar:
            </p>
            <p>
              "La configuración correcta es la diferencia entre una misión exitosa y un desastre cósmico".
            </p>
            <p>
              <h3 className="font-lustra text-2xl text-white text-center mt-6 mb-6">
                Puntos críticos a tener en cuenta
              </h3>
              <div>
              <ul className="list-disc pl-8 space-y-2">
                <li className="text-gray-200">
                  <span className="font-bold">Los Scopes:</span> asegúrense de que los nombres sean exactos
                  y respeten las siguientes denominaciones: <span className="font-bold">GetPayment</span> y <span className="font-bold">CreatePayment</span>.
                </li>
                <li className="text-gray-200">
                  <span className="font-bold">La Tabla DynamoDB:</span> el nombre deberá ser
                  exactamente <span className="font-bold">Payments</span> y el partition key
                  será <span className="font-bold">id</span>. Esta configuración generará automáticamente
                  una variable de ambiente <span className="font-bold">PAYMENTS_TABLE_NAME</span>, que será el faro
                  que guiará a las Lambdas hacia la tabla correcta. Si deciden renombrar la tabla arbitrariamente,
                  bueno... prepárense para modificar el código.
                </li>
                <li className="text-gray-200">
                  <span className="font-bold">El API Gateway:</span> llamen a su puerta de enlace
                  galáctica <span className="font-bold">payments-gateway</span> (si, en minúsculas y con guión medio).
                  No es un nombre cualquiera, es el nombre que abrirá el flujo de las transacciones a través
                  de la vasta red cósmica. Si se equivocan aquí, ni el mejor piloto de la galaxia podrá ayudarles.
                </li>
                <li className="text-gray-200">
                  <span className="font-bold">Las Variables de Ambiente:</span> todas las Lambdas requerirán la
                  variable <span className="font-bold">PAYMENT_PROCESSOR_URL</span> con el siguiente
                  valor: <span className="font-bold">https://bigbang.galactic-payments.gameday.ar.ua.la/v1/payments</span>. Esta URL
                  es la arteria principal que conecta sus pagos con nuestro procesador intergaláctico
                  de confianza, pero ese ya es otro tema...
                </li>
              </ul>
            </div>
            </p>
            <p>
              ¡Buena suerte, {team.name}!  ¡El destino de su aventura comienza aquí... ¡configuren sabiamente!! 🚀
            </p>
          </div>
          <div className="mt-2 mb-2 text-lg space-y-4 text-white">
            Luego de explorar los confines de <span className="font-bold">null/platform</span> y superar los
            obstáculos iniciales, llegará el momento crucial donde deberán elegir una de las aplicaciones (si
            crearon más de una) y declarar el NRN de la elegida para continuar.
            Sin este código, no podrán conectarse a la red intergaláctica de pagos.
          </div>
        </div>
        <div className="mt-2 mb-2 text-lg space-y-4 text-white">
          <div className="mt-4 border-t border-gray-100">
            <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div className="sm:col-span-6">
                <label htmlFor="nullplatform_application_nrn" className="block text-lg font-bold leading-6 text-white">
                  null/platform application NRN
                </label>
                <div className="mt-2">
                  <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-full">
                    <input
                      id="nullplatform_application_nrn"
                      name="nullplatform_application_nrn"
                      type="text"
                      value={newNullplatformApplicationNRN}
                      onChange={(e) => setNullplatformApplicationNRN(e.target.value)}
                      className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-white placeholder:text-gray-400 focus:ring-0 sm:text-base sm:leading-6"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 flex items-center gap-x-6 justify-end">
            <button
              onClick={handleSubmit}
              className="rounded-md bg-blue-700 px-3 py-2 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Episode0;
